export default __webpack_public_path__ + "static/media/usdt-svgrepo-com.517c947d.svg";